<ion-content
  class="profile-screen tw-pt-[16px] tw-pb-[16px] tw-pr-[30px] tw-pl-[30px]"
  [class.active]="responsibleGaming"
>

  <!-- Heading -->
  <div class="heading-section tw-relative">
    <ion-title class="tw-text-center"
      class="
      tw-text-center
      tw-text-[20px]
      tw-font-bold
    "
    data-cy="profile-header"
    >
      Profile
    </ion-title>
    <span (click)="close()"
      class="
      close
      tw-absolute
      tw-capitalize
      tw-text-[16px]
    "
    data-cy="profile-close-button">
      Close
    </span>
  </div>

  <!-- Funding -->
  <div *ngIf="!responsibleGaming" class="funding-section">

    <div class="account-row">
      <p class="label tw-text-[14px]" data-cy="profile_account_balance_text">Account Balance</p>
      <div class="content" data-cy="prof_acct_bal">
        <span class="currency tw-font-bold tw-text-[16px] tw-mr-[10px]" data-cy="profile_account_usd_text">USD</span>
        <span class="amount tw-font-bold tw-text-[25px] tw-text-[#D64C42]" data-cy="profile_account_balance_number">{{ balance | numberWithCommas }}</span>
      </div>
    </div>

    <!-- <div class="promo-row">
      <p class="label" data-cy="prof_promo_txt">Promo Balance</p>
      <div class="content" data-cy="prof_promo_num">
        <span class="currency tw-font-bold tw-text-[16px] tw-mr-[10px]">USD</span>
        <span class="amount tw-font-bold tw-text-[25px] tw-text-[#D64C42]">150</span>
      </div>
    </div> -->

    <div (click)="openFunding()" class="funding-row tw-bg-[#2F80EC] tw-text-center" data-cy="prof-funding">
      <img src="/assets/images/profile/funding_plus_icon.svg" class="tw-inline tw-mr-[5.5px]">
      <span class="tw-text-[14px] tw-color-[#FFFFFF]" data-cy="profile-funding-button">Funding</span>
    </div>
  </div>

  <!-- Profile -->
  <div *ngIf="!responsibleGaming" (click)="openProfile()" class="my-profile-section">
    <p class="label tw-font-bold tw-text-[15px]" data-cy="my-profile-txt">My Profile</p>
    <div class="profile-row">
      <div class="full-name tw-flex">
        <div class="user-icon tw-relative tw-mr-[16px]" data-cy="prof-user-icon">
          <img
            src="/assets/images/profile/verify_icon_light.svg"
            class="l-mode verify tw-absolute tw-inline tw-mr-[5.5px]"
          >
          <img
            src="/assets/images/profile/verify_icon_dark.svg"
            class="d-mode verify tw-hidden tw-absolute tw-inline tw-mr-[5.5px]"
          >
          <span class="tw-text-[20px]">{{ userIcon }}</span>
        </div>
        <div class="user-details" data-cy="prof-user-details">
          <p class="tw-font-bold tw-text-[20px]" data-cy="prof-username">{{ userName }}</p>
          <!-- <p class="tw-text-[17px]" data-cy="prof-user-id">ID: 123456789
            <span class="verified tw-text-[15px]" data-cy="prof-user-verified">
              <i>verified</i>
            </span>
          </p> -->
        </div>
        <ion-icon name="chevron-forward-outline" class="chev-right" data-cy="prof-user-arrow"></ion-icon>
      </div>
    </div>
  </div>

  <!-- Account -->
  <div class="my-account-section">
    <p *ngIf="!responsibleGaming" class="label tw-font-bold tw-text-[15px]" data-cy="my-acct-txt">My Account</p>

    <div
      *ngIf="!responsibleGaming"
      (click)="openAccountSettings()"
      class="account-row"
      data-cy="account-settings"
    >
      <img
        src="/assets/images/profile/account_settings_icon_light.svg"
        class="l-mode tw-inline tw-mr-[19px]"
        data-cy="prof-accSet-iconLight"
      >
      <img
        src="/assets/images/profile/account_settings_icon_dark.svg"
        class="d-mode tw-inline tw-mr-[19px]"
      >
      <span slot="start" class="tw-text-[16px]" data-cy="prof-accSet-txt">Account Settings</span>
      <ion-icon name="chevron-forward-outline" class="chev-right" data-cy="prof-accSet-arrow"></ion-icon>
    </div>

    <div
      *ngIf="!responsibleGaming"
      (click)="openAccountHistory()"
      class="account-row"
      data-cy="open-acc-history"
    >
      <img
        src="/assets/images/account_settings/account-history-light.svg"
        class="l-mode tw-inline tw-mr-[19px]"
        data-cy="prof-accHis-iconLight"
      >
      <img
        src="/assets/images/account_settings/account-history-dark.svg"
        class="d-mode tw-inline tw-mr-[19px]"
      >
      <span slot="start" class="tw-text-[16px]" data-cy="prof-accHis-txt">Account History</span>
      <ion-icon name="chevron-forward-outline" class="chev-right" data-cy="prof-accHis-arrow"></ion-icon>
    </div>

    <div *ngIf="!responsibleGaming" (click)="openBetResults()" class="account-row" data-cy="open-bet-result">
      <img
        src="/assets/images/wager/bet_result_light.svg"
        class="l-mode tw-inline tw-mr-[19px]"
        data-cy="prof-betRes-iconLight"
      >
      <img
        src="/assets/images/wager/bet_result_dark.svg"
        class="d-mode tw-inline tw-mr-[19px]"
      >
      <span slot="start" class="tw-text-[16px]" data-cy="prof-betRes-txt">Bet Result</span>
      <ion-icon name="chevron-forward-outline" class="chev-right" data-cy="prof-betRes-arrow"></ion-icon>
    </div>

    <div
      *ngIf="!responsibleGaming"
      (click)="openPromo()"
      class="account-row promo"
      data-cy="open-promo"
    >
      <img
        src="/assets/images/profile/ticket_icon_light.svg"
        class="l-mode tw-inline tw-mr-[19px]"
        data-cy="prof-promo-iconLight"
      >
      <img
        src="/assets/images/profile/ticket_icon_dark.svg"
        class="d-mode tw-inline tw-mr-[19px]"
      >
      <span slot="start" class="tw-text-[16px]" data-cy="prof-promo-txt">Promo</span>
      <span class="count" data-cy="prof-promo-counter"><i class="badge tw-bg-[#D64C42]" data-cy="prof-promo-badge"></i> 2 Promos</span>
      <ion-icon name="chevron-forward-outline" class="chev-right" data-cy="prof-promo-arrow"></ion-icon>
    </div>

    <div
      (click)="openResponsibleGaming()"
      class="account-row responsible-gaming"
      [class.active]="responsibleGaming"
      data-cy="resp-gaming"
    >
      <img
        src="/assets/images/profile/responsible_gaming_icon_light.svg"
        class="l-mode tw-inline tw-mr-[19px]"
        data-cy="prof-resp-iconLight"
      >
      <img
        src="/assets/images/profile/responsible_gaming_icon_dark.svg"
        class="d-mode tw-inline tw-mr-[19px]"
      >
      <span slot="start" class="tw-text-[16px]" data-cy="prof-resp-txt">Responsible Gaming</span>
      <ion-icon
        *ngIf="!responsibleGaming"
        name="chevron-forward-outline"
        class="close-chev active-chev chev-right"
        data-cy="prof-resp-close"
      ></ion-icon>
      <ion-icon
        *ngIf="responsibleGaming"
        name="chevron-down-outline"
        class="open-chev chev-right"
        data-cy="prof-resp-open"
      ></ion-icon>
    </div>

    <div
      *ngIf="!responsibleGaming"
      (click)="openHelp()"
      class="account-row"
      data-cy="help"
    >
      <img
        src="/assets/images/account_settings/help_icon_light.svg"
        class="l-mode tw-inline tw-mr-[19px]"
        data-cy="prof-help-iconLight"
      >
      <img
        src="/assets/images/account_settings/help_icon_dark.svg"
        class="d-mode tw-inline tw-mr-[19px]"
      >
      <span slot="start" class="tw-text-[16px]" data-cy="prof-help-txt">Help</span>
      <ion-icon name="chevron-forward-outline" class="chev-right" data-cy="prof-help-arrow"></ion-icon>
    </div>

    <!-- Dynamic Content -->
    <!-- Reponsible Gaming -->
    <div
      class="dynamic-content"
      [class.active]="responsibleGaming"
      [class.tw-py-[10px]]="responsibleGaming"
      [class.tw-px-[10px]]="responsibleGaming"
    >
      <feature-ion-responsible-gaming *ngIf="responsibleGaming" (doCloseProfileFn)="close()">
      </feature-ion-responsible-gaming>
    </div>
  </div>

  <div *ngIf="!responsibleGaming" (click)="logout()" data-cy="logout-button"
    class="logout-section tw-flex tw-items-center tw-justify-center tw-p-4">
      <img src="/assets/images/auth/logout_icon.svg" alt="logout icon" class="tw-mr-[10px]" data-cy="prof-logout-icon">
      <span class="action tw-font-bold tw-text-[15px]" data-cy="prof-logout-txt">Logout</span>
  </div>

</ion-content>
